// Minimal, dependency-free utility for active spreadsheet tracking.
// Swap or remove this file to disable the behavior without touching call sites.

const activeState = { current: null as null | number };

export function getActiveSpreadsheetId(): number | null {
  return activeState.current;
}

export function setActiveSpreadsheetId(id: number | null): void {
  activeState.current = id;
}


